import React from 'react';
import { Checkbox, CheckboxGroup } from '../../../components/ui/Checkbox';

const StorageOptionsForm = ({ formData, onChange }) => {
  const handleCheckboxChange = (name, checked) => {
    onChange({
      target: {
        name,
        value: checked
      }
    });
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl md:text-3xl font-semibold mb-2" style={{ color: 'var(--color-text-primary)' }}>
          Storage Options
        </h2>
        <p className="text-sm md:text-base" style={{ color: 'var(--color-text-secondary)' }}>
          Select available storage to optimize meal suggestions
        </p>
      </div>
      <CheckboxGroup label="Available Storage Equipment">
        <Checkbox
          label="Refrigerator"
          description="Enables fresh produce and dairy storage"
          checked={formData?.hasFridge}
          onChange={(e) => handleCheckboxChange('hasFridge', e?.target?.checked)}
        />
        <Checkbox
          label="Freezer"
          description="Allows frozen meat and long-term storage"
          checked={formData?.hasFreezer}
          onChange={(e) => handleCheckboxChange('hasFreezer', e?.target?.checked)}
        />
        <Checkbox
          label="Ice Cooler"
          description="Portable cooling for short-term fresh food storage"
          checked={formData?.hasIceCooler}
          onChange={(e) => handleCheckboxChange('hasIceCooler', e?.target?.checked)}
        />
      </CheckboxGroup>
      <div className="flex items-start gap-3 p-4 rounded-lg" style={{ backgroundColor: 'var(--color-muted)' }}>
        <div className="flex-shrink-0">
          <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'var(--color-primary)' }}>
            <span className="text-lg" style={{ color: 'var(--color-primary-foreground)' }}>💡</span>
          </div>
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium mb-1" style={{ color: 'var(--color-text-primary)' }}>
            Storage Impact
          </p>
          <p className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>
            Your storage selections directly affect meal planning algorithms. Without refrigeration, the system will prioritize shelf-stable ingredients and canned goods.
          </p>
        </div>
      </div>
    </div>
  );
};

export default StorageOptionsForm;